import { useReturnAuthStatusChangeContext } from '../ReturnAuthStatusChange';
import { getAttribute } from '@broadleaf/admin-components/dist/metadata/utils/MetadataUtils';
import { AuroraPayInvoiceFetch } from 'app/oms/components/AuroraPayInvoiceFetch';
import { get, isEmpty, merge } from 'lodash';
import { useContextParams } from 'app/oms/components/ItemsOrderViewSection/components/FulfillmentCard/hooks';

export const FetchReturnAuroraPayInvoice = props => {
  const { actionDefinition, returnAuth } = props;
  const context = useReturnAuthStatusChangeContext({ ...props });

  const contextParams = useContextParams(
    { workaround: true }, // workaround so sandbox does not get added to params
    null,
    null
  );
  const finalParams = merge(contextParams, {
    returnAuthId: returnAuth.id,
    orderId: returnAuth.orderId
  });

  const isFleetAcct = get(context, 'order.fleetAcct', false);
  const allowedStatuses = getAttribute(actionDefinition, 'allowedStatuses', []);
  const display =
    isFleetAcct &&
    (isEmpty(allowedStatuses) || allowedStatuses.includes(returnAuth.status));
  if (!display) {
    return null;
  }

  return (
    <AuroraPayInvoiceFetch
      actionDefinition={actionDefinition}
      contextParams={finalParams}
    />
  );
};
